import { featured } from '@/mocks/manga';
import type { MangaItem } from '@/mocks/manga';

interface Props {
  onOpen: (item: MangaItem) => void;
}

const exclusiveList = featured.filter((m) => m.exclusive || m.preview).slice(0, 5);

export default function Exclusive({ onOpen }: Props) {
  const lead = exclusiveList[0];
  const rest = exclusiveList.slice(1);

  return (
    <section id="exclusive" className="mx-auto w-full max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-flashlight-fill text-accent-600"></i>
            抢先放送
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">独家翻译 · 抢先看新作</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            喵趣漫画网独家汉化出品，领先全网上新，未删减高清原版第一时间奉上。
          </p>
        </div>
        <a
          href="#featured"
          className="inline-flex items-center whitespace-nowrap rounded-full border border-accent-300 bg-accent-50 px-5 py-2 text-sm font-semibold text-accent-800 transition-colors hover:bg-accent-100"
        >
          全部抢先新作
          <i className="ri-arrow-right-line ml-1 text-base"></i>
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div
          onClick={() => onOpen(lead)}
          className="group relative min-h-[380px] cursor-pointer overflow-hidden rounded-2xl bg-background-900 lg:col-span-2"
        >
          <img
            src={lead.cover}
            alt={`${lead.title} 独家抢先看`}
            className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/30 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-6 md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">抢先看</span>
              <span className="rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">独家汉化</span>
              <span className="rounded-full bg-background-950/50 px-2 py-0.5 text-xs text-background-50">{lead.category}</span>
            </div>
            <h3 className="font-heading text-2xl text-background-50 md:text-3xl">{lead.title}</h3>
            <p className="max-w-lg text-sm leading-relaxed text-background-100">{lead.desc}</p>
            <div className="mt-1 flex flex-wrap items-center gap-3 text-xs text-background-100">
              <span>{lead.latest}</span>
              <span>·</span>
              <span>{lead.updateTime}</span>
              <span>·</span>
              <span>评分 {lead.rating}</span>
            </div>
            <span className="mt-1 inline-flex w-fit items-center whitespace-nowrap rounded-full bg-background-50 px-5 py-2 text-sm font-semibold text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              立即抢先看
              <i className="ri-arrow-right-line ml-1 text-base"></i>
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {rest.map((item) => (
            <div
              key={item.id}
              onClick={() => onOpen(item)}
              className="group flex cursor-pointer gap-3 rounded-2xl border border-background-200 bg-background-50 p-2 transition-all hover:-translate-y-0.5 hover:border-accent-300"
            >
              <div className="relative h-24 w-16 shrink-0 overflow-hidden rounded-lg bg-background-100">
                <img src={item.cover} alt={`${item.title} 封面`} className="h-full w-full object-cover" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
                <h3 className="truncate text-sm font-bold text-foreground-950">{item.title}</h3>
                <p className="truncate text-xs text-foreground-600">{item.category} · {item.latest}</p>
                <div className="flex flex-wrap gap-1">
                  {item.preview && (
                    <span className="rounded-md bg-accent-100 px-1.5 py-0.5 text-[10px] font-bold text-accent-800">抢先看</span>
                  )}
                  {item.exclusive && (
                    <span className="rounded-md bg-primary-100 px-1.5 py-0.5 text-[10px] font-bold text-primary-700">独家</span>
                  )}
                </div>
              </div>
              <span className="flex items-center text-xs font-semibold text-primary-500 opacity-0 transition-opacity group-hover:opacity-100">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}